// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sub-el-icon[data-v-31ea41b3] {\r\n  color: currentColor;\r\n  width: 1em;\r\n  height: 1em;\n}\r\n", ""]);
// Exports
module.exports = exports;
